import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import TwoFactorSetup from "../components/TwoFactorSetup";
import { useAuth } from "../context/AuthContext";

export default function Enroll2FA() {
  const { user, refresh } = useAuth();
  const nav = useNavigate();
  const [enrolled, setEnrolled] = useState(false);

  useEffect(() => {
    if (user?.totp_enabled) setEnrolled(true);
  }, [user]);

  const onChange = async () => {
    await refresh();
    setEnrolled(true);
  };

  return (
    <Layout>
      <div className="max-w-2xl">
        <div className="kicker">Security · Required</div>
        <h1 className="font-serif text-3xl md:text-4xl text-[var(--pa-text)] mt-2" data-testid="enroll-2fa-title">
          Set up two-factor authentication
        </h1>
        <p className="mt-3 text-sm text-[var(--pa-text-muted)]">
          Your 7-day grace period has ended. ProsthoAI requires 2FA on all clinical
          accounts to protect patient information. Set it up below, then you can
          continue.
        </p>
        <div className="gold-divider my-6" />

        <TwoFactorSetup onChange={onChange} />

        {enrolled && (
          <div className="mt-6 flex justify-end">
            <button
              onClick={() => nav("/dashboard", { replace: true })}
              data-testid="enroll-2fa-continue"
              className="bg-[var(--pa-gold)] text-[var(--pa-bg)] font-semibold rounded-md px-6 py-2.5 hover:bg-[var(--pa-gold-hover)] transition"
            >
              Continue to Dashboard →
            </button>
          </div>
        )}
      </div>
    </Layout>
  );
}
